import { actionCreator } from '@shared/actions/actions';
export const UpdateUserFavouriteFetchDataStatusAction = 'UpdateUserFavouriteFetchDataStatusAction';
export const createUpdateUserFavouriteFetchDataStatusAction = actionCreator(UpdateUserFavouriteFetchDataStatusAction);
export const ReceiveUserFavouriteDataAction = 'ReceiveUserFavouriteDataAction';
export const createReceiveUserFavouriteDataAction = actionCreator(ReceiveUserFavouriteDataAction);
export const DeleteUserFavouriteItemAction = 'DeleteUserFavouriteItemAction';
export const createDeleteUserFavouriteItemAction = actionCreator(DeleteUserFavouriteItemAction);
export const UpsertUserFavouriteItemAction = 'UpsertUserFavouriteItemAction';
export const createUpsertUserFavouriteItemAction = actionCreator(UpsertUserFavouriteItemAction);
export const FavouriteAppsPricingDataReceivedAction = 'FavouriteAppsPricingDataReceivedAction';
export const createFavouriteAppsPricingDataReceivedAction = actionCreator(FavouriteAppsPricingDataReceivedAction);
